import X from '@ali/xcore/core';
import InvokerAjax from './invokers/ajax';
import InvokerQianniu from './invokers/qianniu-pc';
import API_TYPE from './plugins/qianniu-pc-api-type';
import ajax from './plugins/ajax';
import app from './plugins/qianniu-pc-app';
import env from './plugins/qianniu-pc-env';
import gateway from './plugins/qianniu-pc-gateway';
import top from './plugins/qianniu-pc-top';
import {on, off, emit} from './plugins/qianniu-pc-event';
import {regEvent, unregEvent, postEvent} from './plugins/event.old.js';
import autoPlug from './plugins/qianniu-pc-auto-plug';

let {QN_APP, QN_GATEWAY, TOP} = API_TYPE;

X
  .addInvoker(InvokerAjax)
  .addInvoker(InvokerQianniu(QN_APP))
  .addInvoker(InvokerQianniu(QN_GATEWAY))
  .addInvoker(InvokerQianniu(TOP))
  .addInvoker(InvokerQianniu())

X.plug({
  API_TYPE,

  ajax,
  app,
  env,
  gateway,
  top,

  on,
  off,
  emit,

  regEvent,
  unregEvent,
  postEvent,

  autoPlug,
});

export default X;



// WEBPACK FOOTER //
// ./src/index.js